<template>
	<!-- 商品收藏、浏览历史 -->
	<div>
		<div class="product-list">
			<div v-if="goodsLoading">
				<el-skeleton :loading="goodsLoading" animated>
					<template slot="template">
						<div style="display: flex;">
							<div style="margin-right: 20px;padding: 15px;" v-for="(item,index) in 4" :key="index">
								<el-skeleton-item variant="image" style="width: 200px; height: 200px;" />
								<div style="padding-top: 10px;">
									<el-skeleton-item variant="h3" style="width: 50%;" />
									<div class="product-price">
										<el-skeleton-item variant="text" style="margin-right: 16px;" />
										<el-skeleton-item variant="text" style="width: 30%;" />
									</div>
								</div>
							</div>
						</div>
					</template>
				</el-skeleton>
			</div>
			<!-- 商品收藏 -->
			<div class="product-item" v-for="(product,index) in products" :key="index" @click="handleDetail(product)"
				v-if="!goodsLoading&&source=='collection'">
				<div class="product-image" :style="{height:productItemWidth+'px !important'}">
					<img :src="product.image || product.small">
				</div>
				<div style="padding: 10px;">
					<div class="product-name" :title="product.goodsName">{{ product.goodsName }}</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<div class="product-price">
							<span>{{currencySymbol}}</span>
							<span style="margin-left: 3px;">{{ product.price?product.price.toFixed(2):0 }}</span>
						</div>
						<div class="save-item" @click.stop="delGoodsCollection(product.goodsId,index)">
							<i class="el-icon-star-on" style="font-size: 20px;"></i> {{ $t('saveItem') }}
						</div>
					</div>
				</div>
			</div>
			<div class="nodata" v-if="products.length==0&&!goodsLoading" style="margin-top: 150px;">
				<img src="/icon/common/nodata.png">
				<span>{{$t('noData')}}</span>
			</div>
		</div>

		<!-- 浏览历史记录 -->
		<div v-for="(item,index) in products" :key="index" v-if="!goodsLoading&&source=='footprint'"
			:style="{marginTop:index==0?'-20px':'0'}">
			<el-divider content-position="left">{{item.timeKey}}</el-divider>
			<div class="product-list">
				<div class="product-item" v-for="(product,index) in item.childProducts" :key="index"
					@click="handleDetail(product)">
					<div class="product-image" :style="{height:productItemWidth+'px !important'}">
						<img :src="product.image || product.small">
					</div>
					<div style="padding: 10px;">
						<div class="product-name" :title="product.goodsName">{{ product.goodsName }}</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<div class="product-price">
								<span>{{currencySymbol}}</span>
								<span style="margin-left: 3px;">{{ product.price.toFixed(2) }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div style="display: flex;width: 1200px;justify-content: center;">
			<!-- 加载更多状态 -->
			<div v-if="loadingMore" class="loading-more" style="margin: 30px 0; text-align: center;">
				<i class="el-icon-loading"></i>
				<span>{{$t('dataLoading')}}</span>
			</div>

			<!-- 已加载全部数据 -->
			<div v-if="!hasMore&&products.length>0" class="load-all"
				style="margin: 30px 0; text-align: center; color: #999;">
				{{$t('loadingFinish')}}
			</div>
		</div>
	</div>
</template>

<script>
	import storage from "@/utils/storage.js";
	import collectionApi from "@/api/collection";
	import footPrintApi from "@/api/footprint"
	export default {
		name: 'ProductList',
		props: {
			//商品关键词
			searchKeyword: {
				type: String,
				default: null
			},
			//调用组件来源,collection-收藏，footprint-浏览历史
			source: {
				type: String,
				default: 'collection'
			}
		},
		data() {
			return {
				dateMap: {},
				newProduct: [],
				productItemWidth: 0,
				goodsLoading: true, //是否显示骨架
				products: [],
				currencySymbol: '',
				params: {
					pageNumber: 1,
					pageSize: 10
				},
				loadingMore: false, // 加载更多的状态
				hasMore: true, // 是否还有更多数据
				isMounted: false, // 组件是否已挂载
				accessToken: storage.getToken(),
				count: 0, //已经获取到的数据总数
			}
		},
		mounted() {
			// 组件挂载后添加滚动事件监听器
			this.isMounted = true;
			window.addEventListener('scroll', this.handleScroll);
			// 组件销毁时移除滚动事件监听器
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll);
			});
		},
		methods: {
			init() {
				this.newProduct = [];
				this.count = 0;
				this.dateMap = {};
				this.products = [];
				this.goodsLoading = true;
				this.params.pageNumber = 1;
				this.hasMore = true;
				this.currencySymbol = storage.getCurrencySymbol();
				window.scrollTo({
					top: this.scrollTop,
					behavior: 'smooth'
				})
				this.getGoodsList();
			},
			async getGoodsList() {
				try {
					var params = {
						...this.params,
						rateCode: storage.getCurrency()
					}
					params.order = "desc";
					params.sort = "createTime";
					params.goodsName = this.searchKeyword || '';

					var products = [];
					var total = 0;
					if (this.source == 'collection') {
						params.notConvert = true;
						const res = await collectionApi.getGoodsCollectionList(params);
						products = res.result.records;
						total = res.result.total;
						this.count += products.length;
					} else {
						const res = await footPrintApi.getFootPrintList(params);
						products = res.result.records;
						total = res.result.total;
						this.count += products.length;
						//按日期分组分装数据
						products.map(item => {
							var timeKey = this.formatDate(item.footPrintTime);
							if (!this.dateMap[timeKey]) {
								this.dateMap[timeKey] = timeKey;
								this.newProduct.push({
									timeKey,
									childProducts: []
								})
							}
						})
						this.newProduct.map(item => {
							products.map(element => {
								var timeKey = this.formatDate(element.footPrintTime);
								if (item.timeKey == timeKey) {
									item.childProducts.push(element);
								}
							})
						})
						products = this.newProduct;
					}

					// 检查是否是第一页加载
					if (this.params.pageNumber === 1) {
						// 第一页直接替换数据
						this.products = products;
					} else {
						if (this.source == 'collection') {
							this.products = [...this.products, ...products];
						} else {
							this.products = this.newProduct;
						}

					}
					if (this.count >= total) {
						this.hasMore = false;
					}

					// 重置加载状态
					this.goodsLoading = false;
					this.loadingMore = false;

					// 获取product-item的宽度
					this.$nextTick(() => {
						this.getProductItemWidth();
					});
				} catch (error) {
					console.error('获取商品列表失败:', error);
					if (this.params.pageNumber === 1) {
						this.products = [];
					}
					// 重置加载状态
					this.goodsLoading = false;
					this.loadingMore = false;
				}
			},
			formatDate(dateStr) {
				if (!dateStr) return '';
				const date = new Date(dateStr);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			},

			// 加载更多数据
			loadMore() {
				if (this.loadingMore || !this.hasMore || this.goodsLoading) {
					return;
				}

				this.loadingMore = true;
				this.params.pageNumber++;
				this.getGoodsList();
			},

			// 处理滚动事件
			handleScroll() {
				if (!this.isMounted || this.loadingMore || !this.hasMore) {
					return;
				}
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				const clientHeight = document.documentElement.clientHeight || window.innerHeight;

				// 当距离底部小于230px时，加载更多数据
				if (scrollHeight - scrollTop - clientHeight < 230) {
					this.loadMore();
				}
			},
			//跳转商品详情页
			handleDetail(row) {
				window.open('/product-detail?goodsId=' + row.id);
			},
			// 获取product-item的宽度
			getProductItemWidth() {
				// querySelector只会返回匹配的第一个元素，符合需求
				const productItem = document.querySelector('.product-item');
				if (productItem) {
					// 获取元素的宽度
					this.productItemWidth = productItem.offsetWidth;
					console.log(this.productItemWidth)
				}
			},
			//取消收藏商品
			async delGoodsCollection(goodsId, index) {
				if (!this.accessToken) {
					this.handleLogin();
				} else {
					const res = await collectionApi.delGoodsCollection(goodsId);
					if (res.code == 200) {
						this.$message.success(this.$t('saveItemCancel'));
						this.products.splice(index, 1);
					} else {
						this.$message.warning(this.$t('saveItemFail'));
					}
				}
			},
			handleLogin() {
				this.$confirm(this.$t('loginMessage'), this.$t('tip'), {
					confirmButtonText: this.$t('gotoLogin'),
					cancelButtonText: this.$t('closeLogin'),
					type: 'warning'
				}).then(() => {
					this.$router.push('/login')
				}).catch(() => {
					// 处理取消事件，避免报错
				})
			},
		}
	}
</script>

<style scoped>
	.save-item {
		display: flex;
		align-items: center;
		color: #F59A23;
		font-size: 14px;
	}

	.product-list {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
		gap: 15px;
		max-width: 1200px;
		margin: 0 auto 25px auto;
	}

	.product-item {
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		text-align: center;
		transition: all 0.3s ease;
		position: relative;
		cursor: pointer;
	}

	.product-item:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		transform: translateY(-2px);
	}

	/* 选择货源按钮样式 */
	.select-source-btn-container {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 2;
		opacity: 0;
		transition: opacity 0.3s ease;
		pointer-events: none;
	}

	.show-buy-btn {
		background-color: #D9001B;
		border-color: #D9001B;
	}

	.product-item:hover .select-source-btn-container {
		opacity: 1;
		pointer-events: auto;
	}

	/* 确保按钮在图片上方显示 */
	.product-image {
		position: relative;
		z-index: 1;
	}

	.product-image {
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	.product-image img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
		transition: transform 0.3s ease;
		border-radius: 8px;
	}

	.product-item:hover .product-image img {
		transform: scale(1.05);
	}

	.product-name {
		font-size: 15px;
		color: #333;
		margin-bottom: 10px;
		height: 40px;
		line-height: 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: left;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.product-price {
		font-size: 20px;
		font-weight: bold;
		color: #F59A23;
		text-align: left;
	}

	.product-sale {
		font-size: 14px;
		color: #999;
	}

	/* 加载中动画效果 */
	.loading-more {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		gap: 10px;
	}

	.loading-more .el-icon-loading {
		font-size: 24px;
		color: #666;
		animation: rotating 2s linear infinite;
	}

	.loading-more span {
		margin-left: 10px;
		color: #999;
		font-size: 16px;
	}

	@keyframes rotating {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

	/* 已全部加载样式 */
	.load-all {
		font-size: 16px;
		padding: 10px 0;
	}
</style>